import { render, staticRenderFns } from "./BannerBenefitsComponent.vue?vue&type=template&id=7cf9988a&scoped=true"
import script from "./BannerBenefitsComponent.vue?vue&type=script&lang=js"
export * from "./BannerBenefitsComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerBenefitsComponent.vue?vue&type=style&index=0&id=7cf9988a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf9988a",
  null
  
)

export default component.exports